import gql from 'graphql-tag';

const WDT_CLASSROOM_SETTINGS_FRAGMENT = gql`
  fragment BaseWdtClassroomSettings on WdtClassroomSettings {
    handedness {
      leftHanded
      rtlCrossStroke
    }
    characterOrder {
      numbers
      capitals
      lowercase
    }
  }
`;

export default WDT_CLASSROOM_SETTINGS_FRAGMENT;
